<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">

                <div>
                    <el-select v-model="query.status" size="small" style="width: 140px;margin-right: 10px"
                               placeholder="订单状态">
                        <el-option key="1" label="全部有效订单" value="-1"></el-option>
                        <el-option key="2" label="未付款" value="0"></el-option>
                        <el-option key="3" label="待审核" value="10"></el-option>
                        <el-option key="4" label="待发货" value="1"></el-option>
                        <el-option key="5" label="待收货" value="2"></el-option>
                        <el-option key="6" label="已完成" value="3"></el-option>
                        <el-option key="7" label="售后列表" value="5"></el-option>
                        <el-option key="8" label="已作废" value="9"></el-option>
                        <el-option key="9" label="审核未通过" value="11"></el-option>
                    </el-select>
                    <el-input v-model="query.consigneeName" placeholder="患者姓名" suffix-icon="el-icon-search"
                              size="small" class="input-width mr20"></el-input>
                    <el-input v-model="query.consigneePhone" placeholder="手机号" suffix-icon="el-icon-search"
                              size="small" class="input-width mr20"></el-input>
                    <el-input v-model="query.orderNumber" placeholder="订单编号" suffix-icon="el-icon-search"
                              size="small" class="input-width mr20"></el-input>
                    <el-select v-model="query.pharmacyId" size="small" placeholder="选择药房"
                               style="width: 140px;margin-right: 10px">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in pharmacies" :key="item.id"
                                   :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <el-input v-model="query.doctorName" placeholder="医生姓名" suffix-icon="el-icon-search"
                              size="small" class="input-width"></el-input>
                </div>

                <span style="font-size: 14px">支付时间:
                    <el-date-picker
                            class="date-bg"
                            size="small"
                            v-model="date"
                            type="datetimerange"
                            @change="dateChange"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>

                </span>
                <el-button type="primary" @click="ExportPage" style="height: 30px">导出</el-button>
                <!--
                <div>




                </div>
                -->

            </div>
            <el-table
                    v-loading="loading"
                    :data="tableData">
                <el-table-column prop="orderNumber" label="处方单号" width="140px" fixed></el-table-column>
                <el-table-column prop="pharmacyName" label="药房" width="120px" fixed></el-table-column>
                <el-table-column prop="doctorName" label="医生姓名" width="120px" fixed></el-table-column>
                <el-table-column prop="patientName" width="120px" label="患者" fixed></el-table-column>
                <el-table-column prop="consigneeName" width="140px" label="收货人姓名"></el-table-column>
                <el-table-column prop="consigneePhone" width="140px" label="收货人手机号"></el-table-column>
                <el-table-column label="付款时间" width="200px">
                    <template slot-scope="scope" v-if="scope.row.payTime">
                        <span>{{scope.row.payTime.slice(0,10)}} {{scope.row.payTime.slice(11,19)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="开方时间" width="200px">
                    <template slot-scope="scope" v-if="scope.row.createTime">
                        <span>{{scope.row.createTime.slice(0,10)}} {{scope.row.createTime.slice(11,19)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="priceTotal" width="120px" label="订单金额">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pharmacyId=='35'">{{scope.row.priceMedicineTotal}}</span>
                        <span v-else>{{scope.row.priceTotal}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="priceMedicineTotal" width="120px" label="药品金额"></el-table-column>
                <el-table-column label="是否代煎" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.needFry == 0">不代煎</span>
                        <span v-else-if="scope.row.needFry == 1">代煎</span>
                        <span v-else>不代煎</span>
                    </template>
                </el-table-column>
                <el-table-column label="处方类型" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.typeCode == 'KE_LI'">颗粒</span>
                        <span v-else-if="scope.row.typeCode == 'YING_PIAN'">饮片</span>
                        <span v-else-if="scope.row.typeCode == 'GAO_FANG'">膏方</span>
                        <span v-else-if="scope.row.typeCode == 'WAN_JI'">丸剂</span>
                        <span v-else>中成药西药</span>
                    </template>
                </el-table-column>
                <el-table-column label="处方子类型" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.categoryCode == 'NONG_SUO_MI_WAN'">浓缩蜜丸</span>
                        <span v-else-if="scope.row.categoryCode == 'NONG_SUO_SHUI_WAN'">浓缩水丸</span>
                        <span v-else-if="scope.row.categoryCode == 'SHUI_WAN'">水丸</span>
                        <span v-else-if="scope.row.categoryCode == 'SHUI_MI_WAN'">水蜜丸</span>
                        <span v-else-if="scope.row.categoryCode == 'MI_WAN'">蜜丸</span>
                        <span v-else> </span>
                    </template>
                </el-table-column>
                <el-table-column prop="site" width="230px" label="收货地址">
                    <template slot-scope="scope">
                        <span v-if="scope.row.consigneeProvince!==''">{{scope.row.consigneeProvince}}</span>
                        <span v-if="scope.row.consigneeCity!==''">{{scope.row.consigneeCity}}</span>
                        <span v-if="scope.row.consigneeDistrict!==''">{{scope.row.consigneeDistrict}}</span>
                        <span v-if="scope.row.consigneeDetailAddress!==''">{{scope.row.consigneeDetailAddress}}</span>
                        <span>(未经同意不得代收,任何问题可拨打0573-83833630)</span>
                    </template>
                </el-table-column>
                <el-table-column prop="logisticsNumber" width="120px" label="快递单号"></el-table-column>
                <el-table-column width="120px" label="订单状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '0'">待付款</span>
                        <span v-else-if="scope.row.status == '1'&&scope.row.isAudiding==0">待审核</span>
                        <span v-else-if="scope.row.status == '11'">审核不通过</span>
                        <span v-else-if="scope.row.status == '1'&&scope.row.isAudiding==1">待发货</span>
                        <span v-else-if="scope.row.status == '2'">待收货</span>
                        <span v-else-if="scope.row.status == '3'">已完成</span>
                        <span v-else-if="scope.row.status == '4'">售后中</span>
                        <span v-else-if="scope.row.status == '5'">以退款</span>
                        <span v-else-if="scope.row.status == '9'">已作废</span>
                    </template>
                </el-table-column>
                <el-table-column prop="doctorMessage" width="120px" label="医生备注"></el-table-column>
                <el-table-column label="操作" width="360px" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="print(scope.row)">打印</el-button>
                        <el-button type="text" @click="printRecipe(scope.row)">打印处方笺</el-button>
                        <el-button type="text" @click="openUpdateAdvise(scope.row)">修改医嘱</el-button>
                        <el-button type="text" @click="openDetail(scope.row)">处方明细</el-button>
                        <el-button type="text" @click="openAfter(scope.row)">售后</el-button>
                        <div v-if="scope.row.authority== '0' &&scope.row.status == '1'">
                            <el-button type="text" @click="getPharmacy(scope.row)" style="float: left">更换药房</el-button>
                        </div>

                        <div v-if="(scope.row.authority== '3'||scope.row.authority== '2'
                        ||scope.row.authority== '5'||scope.row.authority== '0') &&scope.row.status== '0'">
                            <el-button type="text" @click="abandonedOrder(scope.row)" style="float: left">作废</el-button>
                        </div>
                        <div v-if="scope.row.status == '1' && (scope.row.authority== '3'||scope.row.authority== '5'
                        ||scope.row.authority== '0')&&scope.row.isAudiding==0" style="float: left">
                            <el-button type="text" @click="openAudit(scope.row)">审核</el-button>
                        </div>
                        <div v-if="scope.row.status == '0' &&
                        (scope.row.authority== '2'||scope.row.authority== '5'||scope.row.authority== '0')">
                            <el-button type="text" @click="confirmCharge(scope.row)">收款</el-button>
                        </div>

                        <div v-else-if="scope.row.status == '1'
                        &&(scope.row.authority== '0'||scope.row.authority== '3')&&scope.row.isAudiding==1">
                            <el-button type="text"
                                       @click="openShipments(scope.row)">发货
                            </el-button>
                            <el-dropdown @command="handleCommand">
                                <span class="el-dropdown-link">
                                    更多操作<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-show="scope.row.status == '1'"
                                                      :command="composeValue('receivingEdit',scope.row)">修改收货信息
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div v-else-if="scope.row.status == '2'&& scope.row.authority== '0'">
                            <el-dropdown @command="handleCommand">
                                <span class="el-dropdown-link">
                                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="composeValue('updateTrackingNumber',scope.row)">修改物流信息
                                    </el-dropdown-item>
                                    <el-dropdown-item :command="composeValue('receivedOrder',scope.row)">改为已收货
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>

                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="处方详情" :visible.sync="detailVisible" width="641px" :close-on-click-modal="false">
            <div style="margin-top: -20px;font-size: 14px">
                <div style="height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                    <div style="min-width: 120px">患者资料:
                        <span>{{orderMessage.patientName}}</span>
                    </div>
                    <div style="min-width: 40px;margin-left: 20px">
                        <span v-if="orderMessage.patientSex == '2'">女</span>
                        <span v-else-if="orderMessage.patientSex == '1'">男</span>
                    </div>
                    <div style="min-width: 40px;margin-left: 20px">{{orderMessage.patientAge}}岁</div>
                </div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0">
                    <span>诊断信息:{{orderMessage.doctorDiagnose}}</span>
                </div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0">
                    <span>医嘱:{{orderMessage.doctorAdvice}}</span>
                </div>
                <div class="line" style="margin: 5px 0"></div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0">
                    处方剂型:<span v-if="orderMessage.type == '0'">颗粒</span>
                    <span v-if="orderMessage.type == '1'">饮片</span>
                    <span v-if="orderMessage.type == '2'">膏方</span>
                    <span v-if="orderMessage.type == '101'">粉剂</span>
                    <span v-if="orderMessage.type == '102'">膏药</span>
                    <span v-if="orderMessage.type == '103'">中成药</span>
                    <span v-if="orderMessage.type == '104'">专病专方</span>
                    <span v-if="orderMessage.type == '201'">辅料</span>
                </div>
                <div style="min-height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                    <span>处方明细:</span>
                    <div style="display: flex;flex-direction: row;flex-wrap:wrap;width: 410px;">
                        <div style="width: 100px;" v-for="item in orderMessage.items">
                            <span v-if="item.convertQuantity != null">
                                {{item.name}}×{{item.convertQuantity}}<span v-if="orderMessage.decoctionMethod!=null">*{{orderMessage.decoctionMethod}}</span>
                            </span>
                            <span v-if="item.convertQuantity == null">
                            {{item.name}}×{{item.count}}<span v-if="orderMessage.decoctionMethod!=null">*{{orderMessage.decoctionMethod}}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                    <div style="min-width: 120px">剂数:{{orderMessage.count}}</div>
                </div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                    <div style="min-width: 120px">服法用量:{{orderMessage.orderUsage}}</div>
                </div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                    <div style="min-width: 120px">订单备注:{{orderMessage.doctorMessage}}</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="detailVisible = false" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="发货" :visible.sync="shipmentsVisible" width="520px" :close-on-click-modal="false">
            <el-form :model="courier" ref="courier" :rules="rules" size="small" label-width="100px">
                <div class="line" style="margin-bottom: 15px"></div>
                <el-form-item label="发货快递:" prop="logisticsCompany">
                    <el-select v-model="courier.logisticsCompany" size="small" style="width: 140px;margin-right: 10px"
                               placeholder="快递公司">
                        <el-option key="1" label="顺丰" value="1"></el-option>
                        <el-option key="2" label="圆通" value="2"></el-option>
                        <el-option key="3" label="申通" value="3"></el-option>
                        <el-option key="4" label="韵达" value="4"></el-option>
                        <el-option key="6" label="邮政" value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="快递单号:" prop="trackingNumber">
                    <el-input v-model="courier.trackingNumber" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="shipmentsVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmShipments" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="审核" :visible.sync="auditVisible" width="641px" :close-on-click-modal="false">
            <div style="margin-top: -20px;font-size: 14px">
                <div style="height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                    <div style="min-width: 120px">患者资料:
                        <span>{{orderMessage.patientName}}</span>
                    </div>
                    <div style="min-width: 40px;margin-left: 20px">
                        <span v-if="orderMessage.patientSex == '2'">女</span>
                        <span v-else-if="orderMessage.patientSex == '1'">男</span>
                    </div>
                    <div style="min-width: 40px;margin-left: 20px">{{orderMessage.patientAge}}岁</div>
                </div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0">
                    <span>诊断信息:{{orderMessage.doctorDiagnose}}</span>
                </div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0">
                    <span>医嘱:{{orderMessage.doctorAdvice}}</span>
                </div>
                <div class="line" style="margin: 5px 0"></div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0">
                    处方剂型:<span v-if="orderMessage.type == '0'">颗粒</span>
                    <span v-if="orderMessage.type == '1'">饮片</span>
                    <span v-if="orderMessage.type == '2'">膏方</span>
                    <span v-if="orderMessage.type == '101'">粉剂</span>
                    <span v-if="orderMessage.type == '102'">膏药</span>
                    <span v-if="orderMessage.type == '103'">中成药</span>
                    <span v-if="orderMessage.type == '104'">专病专方</span>
                    <span v-if="orderMessage.type == '201'">辅料</span>
                </div>
                <div style="min-height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                    <span>处方明细:</span>
                    <div style="display: flex;flex-direction: row;flex-wrap:wrap;width: 410px;">
                        <div style="width: 100px;" v-for="item in orderMessage.items">
                            {{item.name}}×{{item.count}}<span v-if="orderMessage.decoctionMethod!=null">*{{orderMessage.decoctionMethod}}</span>
                        </div>
                    </div>
                </div>
                <div style="height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                    <div style="min-width: 120px">服法用量:{{orderMessage.orderUsage}}</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="audit(false)" style="width: 76px">不通过</el-button>
                <el-button type="primary" @click="audit(true)" style="width: 76px">通过</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改地址" :visible.sync="receivingEditVisible" width="530px" :close-on-click-modal="false">
            <el-form :model="receivingEdit" ref="receivingEdit" :rules="rules" size="small" label-width="90px">
                <el-form-item label="收货人:" prop="consigneeName">
                    <el-input v-model="receivingEdit.consigneeName" style="width: 400px"></el-input>
                </el-form-item>
                <el-form-item label="收货电话:" prop="consigneePhone">
                    <el-input v-model="receivingEdit.consigneePhone" style="width: 400px"></el-input>
                </el-form-item>
                <div class="dialog-set">
                    <el-form-item label="省市区:" prop="consigneeProvince">
                        <el-select v-model="receivingEdit.consigneeProvince" placeholder="选择省"
                                   @change="chooseProvince(receivingEdit.consigneeProvince)" style="width: 137px;">
                            <el-option v-for="item in province" :key="item.province"
                                       :label="item.province" :value="item.provinceId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="consigneeCity" label-width="0">
                        <el-select v-model="receivingEdit.consigneeCity" placeholder="选择市"
                                   @change="chooseCity(receivingEdit.consigneeCity)" style="width: 132px">
                            <el-option v-for="item in city" :key="item.city"
                                       :label="item.city" :value="item.cityId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="consigneeDistrict" label-width="0">
                        <el-select v-model="receivingEdit.consigneeDistrict" placeholder="选择区/县"
                                   style="width: 131px;">
                            <el-option v-for="item in area" :key="item.area"
                                       :label="item.area" :value="item.areaId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-form-item label="详细地址:" prop="consigneeDetailAddress">
                    <el-input v-model="receivingEdit.consigneeDetailAddress" style="width: 400px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="receivingEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmReceivingEdit" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="售后信息" :visible.sync="afterVisible" width="530px" :close-on-click-modal="false">
            <el-form :model="afterEdit" ref="afterEdit" :rules="rules1" size="small" label-width="90px">
                <el-form-item label="售后类型:" prop="afterType">
                    <el-select v-model="afterEdit.afterType" size="small" style="width: 140px;margin-right: 10px"
                               placeholder="订单状态">
                        <el-option key="REFUND_ALL" label="全退款" value="REFUND_ALL"></el-option>
                        <el-option key="REFUND_FREIGHT" label="退运费" value="REFUND_FREIGHT"></el-option>
                        <el-option key="REFUND_MEDICINE" label="退药款" value="REFUND_MEDICINE"></el-option>
                        <el-option key="FILL_MEDICINE" label="补收药款" value="FILL_MEDICINE"></el-option>
                        <el-option key="REFUND_MAKE_FRY" label="退制煎费" value="REFUND_MAKE_FRY"></el-option>
                        <el-option key="REFUND_MAKE_GAO" label="退制膏费" value="REFUND_MAKE_GAO"></el-option>
                        <el-option key="REFUND_MAKE_WAN" label="退制丸费" value="REFUND_MAKE_WAN"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="售后金额:" prop="money">
                    <el-input v-model="afterEdit.money" style="width: 400px"></el-input>
                </el-form-item>
                <el-form-item label="备注:" prop="remarks">
                    <el-input v-model="afterEdit.remarks" style="width: 400px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="afterVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAfterEdit" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="打印" :visible.sync="printVisible1" width="530px" :close-on-click-modal="false">
            <div style="height: 50px">
                <p v-if="printData.hiddenContent=='HIDDEN_PRESCRIPTION'">此订单隐藏药品</p>
                <p v-else-if="printData.hiddenContent=='HIDDEN_PRICE'">此订单隐藏金额</p>
                <p v-else-if="printData.hiddenContent=='HIDDEN_ALL'">此订单隐藏全部</p>
                <p v-else-if="printData.hiddenContent=='HIDDEN_NO'" 此订单全部打印></p>
            </div>
            <el-button v-if="printData.hiddenContent=='HIDDEN_PRESCRIPTION'"
                       type="primary"
                       @click="money = true,drug = false,printVisible1=false,printVisible=true" style="width: 100px">
                隐藏药品
            </el-button>
            <el-button v-else
                       @click="money = true,drug = false,printVisible1=false,printVisible=true" style="width: 100px">
                隐藏药品
            </el-button>

            <el-button type="primary" v-if="printData.hiddenContent=='HIDDEN_PRICE'"
                       @click="money = false,printVisible1=false,printVisible=true" style="width: 100px">隐藏金额
            </el-button>
            <el-button v-else
                       @click="money = false,printVisible1=false,printVisible=true" style="width: 100px">隐藏金额
            </el-button>

            <el-button type="primary" v-if="printData.hiddenContent=='HIDDEN_ALL'"
                       @click="money = false,drug = false,printVisible1=false,printVisible=true" style="width: 100px">
                隐藏全部
            </el-button>
            <el-button v-else
                       @click="money = false,drug = false,printVisible1=false,printVisible=true" style="width: 100px">
                隐藏全部
            </el-button>

            <el-button type="primary" v-if="printData.hiddenContent=='HIDDEN_NO'"
                       @click="money = true,drug = true,printVisible1=false,printVisible=true" style="width: 100px">全部打印
            </el-button>
            <el-button v-else
                       @click="money = true,drug = true,printVisible1=false,printVisible=true" style="width: 100px">全部打印
            </el-button>
        </el-dialog>

        <!-- 打印表格容器 -->
        <el-dialog title="打印样式" :visible.sync="printVisible" width="530px" :close-on-click-modal="false">
            <div id="printTable" style="width:410px;">
                <table
                        style="width:100%;text-align:center;border-collapse:collapse;font-family:宋体;font-size:18px;font-weight: bolder;">
                    <tbody id="printContent">
                    <tr>
                        <td colspan="6" height="10"></td>
                    </tr>
                    <tr>
                        <td colspan="6" height="30" style="text-align:left;">
                            订单编号：{{printData.orderNumber}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6" height="30" style="text-align:left;">
                            调配时间：{{printData.payTime}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6" height="30" style="text-align:left;">
                            患者：{{printData.patientName}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3" style="text-align:left;">收货人：{{printData.consigneeName}}</td>
                        <td colspan="3" height="30" style="text-align:right;">{{printData.consigneePhone}}</td>
                    </tr>
                    <tr>
                        <td colspan="6" height="30" style="text-align:left;">
                            {{printData.consigneeProvince}}{{printData.consigneeCity}}{{printData.consigneeDetailAddress}}
                        </td>
                    </tr>
                    <tr style="border-top:1px dashed #111">
                        <td colspan="6" height="30"></td>
                    </tr>
                    <tr>
                        <td colspan="6" height="30"><span>药品: [共{{printData.count}}贴]<br></span><span
                                v-if="drug">&nbsp以下为中药名称&nbsp&nbsp重量:颗粒剂量以实际为准</span></td>
                    </tr>
                    <tr style="text-align:left;" v-if="drug">
                        <td colspan="2" height="30">
                           <span v-for="(item,i) in printData.items">
                               <span style=" font-size:14px">{{item.name}}<span v-if="zzr">&nbsp{{item.count}}克</span>&nbsp<span
                                       v-if="(i+1)%3==0 &&i>=2"><br></span></span>
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td colspan="6" height="60"></td>
                    </tr>
                    <tr style="border-top:1px dashed #111">
                        <td colspan="6" height="50">服用方法:{{printData.orderUsage}}</td>
                    </tr>
                    <tr style="border-bottom:1px dashed #111">
                        <td colspan="6" height="50">医嘱: {{printData.doctorAdvice}}</td>
                    </tr>
                    <span v-if="money">
                    <tr><td colspan="2">药费: </td>
                        <td colspan="4" height="30" style="text-align:right;">{{printData.priceTotal}}元</td>
                    </tr>
                    <tr style="border-bottom:1px dashed #111">
                        <td colspan="2">运费: </td>
                        <td colspan="4" height="30" style="text-align:right;"><span v-if="printData.priceFreight=='0'">包邮</span>{{printData.priceFreight}}元</td>
                    </tr>
                    <tr>
                        <td colspan="2" height="30">合计: </td>
                        <td colspan="4" height="30" style="text-align:right;">{{printData.priceTotal}}元</td>
                    </tr>
                    <tr>
                        <td colspan="2" height="30">人民币 </td>
                       <td>{{printData.priceTotal|toChies}}</td>
                    </tr>

                        </span>
                    </tbody>
                </table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateAdviseVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="updateAdvise" v-print="'#printTable'" style="width: 76px">确定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="更换药房" :visible.sync="pharmacyVisible" width="530px" :close-on-click-modal="false">
            <el-select size="small" v-model="pharmacyId"
                       placeholder="请选择药房" style="width: 170px">
                <el-option
                        v-for="item in pharmacyList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pharmacyVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="exchangePharmacy" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改医嘱" :visible.sync="updateAdviseVisible" width="530px" :close-on-click-modal="false">
            <el-form :model="doctorAdviceEdit" ref="doctorAdviceEdit" :rules="rules2" size="small" label-width="90px">
                <el-form-item label="医嘱:" prop="doctorAdvice">
                    <el-input type="textarea" v-model="doctorAdviceEdit.doctorAdvice" style="width: 400px"></el-input>
                </el-form-item>
                <el-form-item label="服用方法:" prop="consigneePhone">
                    <el-input type="textarea" v-model="doctorAdviceEdit.usage" style="width: 400px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateAdviseVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="updateAdvise" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="请输入导出条数" :visible.sync="ExportPageVisible" width="530px" :close-on-click-modal="false">
            <el-form :model="Export" ref="ExportPageSize" :rules="rules3" size="small" label-width="90px">
                <el-form-item label="条数:" prop="ExportPageSize">
                    <el-input v-model="Export.ExportPageSize" style="width: 100px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateAdviseVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="ExportOrder()" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改收货地址" :visible.sync="updateTrackingNumberVisible" width="530px"
                   :close-on-click-modal="false">
            <el-form size="small" label-width="90px">
                <el-form-item label="快递单号:" prop="TrackingNumber">
                    <el-input type="TrackingNumber" v-model="TrackingNumber" style="width: 300px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateTrackingNumberVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="updateTrackingNumber()" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <!-- 打印表格容器 -->
        <el-dialog title="打印处方笺" :visible.sync="recipeVisible" width="530px" :close-on-click-modal="false">
            <div id="recipeData" style="width:500px;">
                <table
                        style="width:100%;text-align:center;border-collapse:collapse;font-family: 宋体;font-size:14px;font-weight: bolder;">
                    <tbody id="recipeContent">
                    <tr>
                        <td colspan="6" height="60"><h2>处方笺</h2></td>
                    </tr>
                    <tr>
                        <td colspan="2" height="30" style="text-align:left;">
                            订单编号：{{printData.orderNumber}}
                        </td>
                        <td colspan="2" height="20" style="text-align:left;">
                            开方时间：<span v-if="printData.createTime">{{printData.createTime.slice(0,10)}} {{printData.createTime.slice(11,19)}}</span>
                        </td>
                    </tr>
                    <tr style="border-top:1px solid #111">
                        <td colspan="6" height="20"></td>
                    </tr>
                    <tr>
                        <td height="30" style="text-align:left;" width="130px">
                            姓名：{{printData.patientName}}
                        </td>
                        <td height="30" v-if="printData.patientSex == '1'">
                            性别：男
                        </td>
                        <td height="30" v-else-if="printData.patientSex == '2'">
                            性别：女
                        </td>
                        <td height="30">
                            年龄：{{printData.patientAge}}
                        </td>

                    </tr>
                    <tr>
                        <td colspan="6" height="20" style="text-align:left;">
                            症状及诊断：{{printData.doctorDiagnose}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" style="text-align:left;">收货人：{{printData.consigneeName}}</td>
                        <td colspan="2" height="30" style="text-align:right;">{{printData.consigneePhone}}</td>
                    </tr>
                    <tr>
                        <td colspan="6" height="30" style="text-align:left;">
                            {{printData.consigneeProvince}}{{printData.consigneeCity}}{{printData.consigneeDetailAddress}}
                        </td>
                    </tr>
                    <tr style="border-top:1px solid #111">
                        <td colspan="6"></td>
                    </tr>
                    <tr>
                        <td height="60" style="text-align:left;"><H2>RP:</H2></td>
                    </tr>
                    <!--<tr style="width: 100%">
                        <td width="100%">
                            <el-row style="width: 100%;">
                                <el-col :span="8">
                                    <el-table :data="printDataOneColumn" :show-header=false class="customer-table customer-table-tr">
                                        <el-table-column width="70" prop="name"/>
                                        <el-table-column width="70" :formatter="formatterX"/>
                                    </el-table>
                                </el-col>
                                <el-col :span="8">
                                    <el-table :data="printDataTwoColumn" :show-header=false class="customer-table customer-table-tr">
                                        <el-table-column width="70" prop="name"/>
                                        <el-table-column width="70" :formatter="formatterX"/>
                                    </el-table>
                                </el-col>
                                <el-col :span="8">
                                    <el-table :data="printDataThrColumn" :show-header=false class="customer-table customer-table-tr">
                                        <el-table-column width="70" prop="name"/>
                                        <el-table-column width="70" :formatter="formatterX"/>
                                    </el-table>
                                </el-col>
                            </el-row>
                        </td>
                    </tr>-->

                    <tr style="text-align:left;border: 1px solid #ccc;box-sizing:border-box;">
                        <td colspan="4">
                           <span v-for="(item,i) in printData.items">
                               <span style="width: 30px; font-size:14px">{{item.name}}*
                                   <span v-if="item.convertQuantity != null">
                                        {{item.convertQuantity}}(共{{towNumber(item.convertQuantity*printData.count)}}g)
                                    </span>
                                    <span v-if="item.convertQuantity == null">
                                    {{item.count}}{{item.quantityUnit}}
                                    </span>
                                   &nbsp;
                               <span v-if="(i+1)%3==0 &&i>=2"><br></span>
                               </span>
                            </span>
                        </td>
                    </tr>
                    <tr style="text-align:right">
                        <td>{{printData.count}}剂</td>
                        <td>总克数:{{sumCount(printData.items)}}</td>
                    </tr>
                    <tr style="text-align:right">
                        <td></td>
                        <td height="60">每剂:{{sumOneCount(printData.items)}}</td>
                    </tr>
                    <tr style="text-align:left">
                        <td height="30" colspan="3">制法:{{printData.needFry==0?"不代煎":"代煎"}}</td>
                    </tr>
                    <tr style="text-align:left">
                        <td height="30" colspan="3">服用方法:{{printData.orderUsage}}</td>
                    </tr>
                    <tr style="text-align:left">
                        <td height="30" colspan="3">服用天数:{{printData.takeDays}}天</td>
                    </tr>
                    <tr style="text-align:left">
                        <td height="30" colspan="3">医嘱: {{printData.doctorAdvice}}</td>
                    </tr>
                    <tr style="border-top:1px solid #111;text-align:left">
                        <td height="30" width="100px">医师:{{printData.doctorName}}</td>
                        <td></td>
                        <td height="30" colspan="10" width="200px">药品金额:{{printData.priceTotal}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="recipeVisible=false" style="width: 76px">取消</el-button>
                <el-button type="primary" v-print="'#recipeData'" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>


    function revertUTF8(szInput) {
        var x, wch, wch1, wch2, uch = "", szRet = "";
        for (x = 0; x < szInput.length; x++) {
            if (szInput.charAt(x) == "%") {
                wch = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
                if (!wch) {
                    break;
                }
                if (!(wch & 0x80)) {
                    wch = wch;
                } else if (!(wch & 0x20)) {
                    x++;
                    wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
                    wch = (wch & 0x1F) << 6;
                    wch1 = wch1 & 0x3F;
                    wch = wch + wch1;
                } else {
                    x++;
                    wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
                    x++;
                    wch2 = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
                    wch = (wch & 0x0F) << 12;
                    wch1 = (wch1 & 0x3F) << 6;
                    wch2 = (wch2 & 0x3F);
                    wch = wch + wch1 + wch2;
                }
                szRet += String.fromCharCode(wch);
            } else {
                szRet += szInput.charAt(x);
            }
        }
        return (szRet);
    }

    export default {
        data() {
            return {
                id: "",
                TrackingNumber: "",
                updateTrackingNumberVisible: false,
                Export: {
                    ExportPageNum: 1,
                    ExportPageSize: 100,
                },
                updateAdviseVisible: false,
                pharmacyVisible: false,
                zzr: false,
                drug: true,
                money: true,
                printVisible: false,
                printVisible1: false,
                // token
                authorization: localStorage.getItem('authorization'),
                // 搜索
                date: '',
                query: {
                    status: '-1',
                    consigneeName: '',
                    pharmacyId: '',
                    orderNumber: '',
                    consigneePhone: '',
                    payStartTime: '',
                    payEndTime: '',
                    doctorId: null,
                    doctorName: '',
                    backgroundAccountId: '',
                    haveAfter: null,
                    orderRule: -1,
                },
                // 列表数据
                pageNum: 1,
                pageSize: 10,
                ExportPageNum: 1,
                ExportPageSize: 100,
                ExportPageVisible: false,
                total: 0,
                loading: true,
                tableData: [],
                orderMessage: '',
                province: [],
                city: [],
                area: [],

                // 处方明细
                detailVisible: false,
                // 收款
                chargeVisible: false,
                chargeMessage: {
                    orderWaysToObtain: '1',
                    consigneeName: '',
                    mobile: '',
                    province: '',
                    city: '',
                    district: '',
                    address: '',
                },
                // 发货
                shipmentsVisible: false,
                //审核
                auditVisible: false,
                //售后
                afterVisible: false,
                courier: {
                    logisticsCompany: '',
                    trackingNumber: '',
                },
                rules1: {
                    afterType: [{required: true, message: '请选择售后类型', trigger: 'blur'}],
                    money: [{required: true, message: '请输入售后金额', trigger: 'blur'}],
                    remarks: [{required: true, message: '请输入备注', trigger: 'blur'}],
                },
                rules: {
                    logisticsCompany: [{required: true, message: '请输入发货快递', trigger: 'blur'}],
                    consigneeName: [{required: true, message: '请输入收货人姓名', trigger: 'blur'}],
                    mobile: [{required: true, message: '请输入收货人手机号', trigger: 'blur'}],
                    consigneeMobile: [{required: true, message: '请输入收货人手机号', trigger: 'blur'}],
                    trackingNumber: [{required: true, message: '请输入快递单号', trigger: 'blur'}],
                    consigneePhone: [{required: true, message: '请输入收货人手机号', trigger: 'blur'}],
                    consigneeProvince: [{required: true, message: '请选择收货的省市区', trigger: 'blur'}],
                    consigneeCity: [{required: true, message: '', trigger: 'blur'}],
                    consigneeDistrict: [{required: true, message: '', trigger: 'blur'}],
                    consigneeDetailAddress: [{required: true, message: '请输入收货的详细地址', trigger: 'blur'}],
                },
                rules2: {
                    doctorAdvice: [{required: true, message: '请输入医嘱', trigger: 'blur'}],
                    usage: [{required: true, message: '请输入服用方法', trigger: 'blur'}],
                },
                rules3: {
                    ExportPageSize: [{required: true, message: '请输入条数', trigger: 'blur'}],
                }
                ,
                // 修改收货信息
                receivingEditVisible: false,
                receivingEdit: {},
                afterEdit: {afterType: '0'},
                printData: {},
                printDataOneColumn: [],
                printDataTwoColumn: [],
                printDataThrColumn: [],
                pharmacyId: '',
                pharmacyList: '',
                doctorAdviceEdit: {
                    doctorAdvice: '',
                    usage: ''
                },
                fileName: {
                    'content-type': ''
                },
                recipeVisible: false
            };
        },
        created() {
            this.getData();
            this.getPharmacys();
        },
        methods: {
            openUpdateTrackingNumber(data) {
                this.orderMessage = data;
                this.updateTrackingNumberVisible = true;
                this.TrackingNumber = data.logisticsNumber;
                this.id = data.id;
            },
            updateTrackingNumber() {
                this.axios.post('/api-s/10009/100198?trackingNumber' + this.TrackingNumber + '&id=' + this.id, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success('修改成功')
                        this.orderMessage = ''
                        this.updateTrackingNumberVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(() => {
                    this.$message.error(res.data.message)
                })
            },
            ExportPage() {
                this.ExportPageVisible = true
            },
            //拉起编辑
            openUpdateAdvise(data) {
                this.orderMessage = data;
                this.doctorAdviceEdit.doctorAdvice = data.doctorAdvice;
                this.doctorAdviceEdit.usage = data.orderUsage;
                this.updateAdviseVisible = true
            },
            updateAdvise() {
                this.$refs.doctorAdviceEdit.validate(valid => {
                    if (valid) {
                        let params = {
                            'id': this.orderMessage.id,
                            'doctorAdvice': this.doctorAdviceEdit.doctorAdvice,
                            'orderUsage': this.doctorAdviceEdit.usage
                        }
                        this.axios.post('/api-s/10009/100180/', params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success('修改成功')
                                this.orderMessage = ''
                                this.afterVisible = false
                                this.getData()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        }).catch(() => {
                            this.$message.error(res.data.message)
                        })

                        this.updateAdviseVisible = false
                    }
                })
            }
            ,
            getPharmacy(data) {
                this.orderMessage = data;
                this.pharmacyId = data.pharmacyId
                this.axios.get('/api-b/10008/100130?typeCode=' + data.typeCode, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.pharmacyList = res.data.data
                        if (this.pharmacyList.length === 1) {
                            this.pharmacyId = this.pharmacyList[0].pharmacyId
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                this.pharmacyVisible = true
            },
            print(data) {
                this.printVisible1 = true;
                this.printData = data;
                if (data.doctorName = '郑主任') {
                    this.zzr = true;
                } else {
                    this.zzr = false;
                }
            },
            printRecipe(data) {
                this.recipeVisible = true;
                this.printData = data;
                let newData = data.items
                let l = newData.length
                if (l >= 3) {
                    for (let i = 0; i < l; i += 3) {
                        this.printDataOneColumn.push(newData[i])
                        this.printDataTwoColumn.push(newData[i + 1])
                        this.printDataThrColumn.push(newData[i + 2])
                    }
                }
                console.log(this.printDataOneColumn)
                console.log(this.printDataTwoColumn)
            },
            ExportOrder() {
                this.$refs.ExportPageSize.validate(valid => {
                    if (valid) {
                        this.axios.post('/api-s/10009/100185/' + this.Export.ExportPageNum + "/" + this.Export.ExportPageSize, this.query, {
                            headers: {
                                Authorization: this.authorization,

                            }, responseType: "blob"
                        }).then((response) => {
                                const BLOB = response.data;
                                const headers = response.headers
                                this.fileName = JSON.parse(JSON.stringify(headers));
                                let arr = this.fileName["content-type"].split(";");
                                this.fileName = arr[1];
                                let ar = this.fileName.split("=");
                                this.fileName = ar[1];
                                // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                                const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                                fileReader.readAsDataURL(BLOB);
                                // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                                fileReader.onload = (event) => {
                                    // 处理load事件。该事件在读取操作完成时触发
                                    // 新建个下载的a标签，完成后移除。
                                    let a = document.createElement("a");
                                    a.download = revertUTF8(this.fileName);
                                    a.href = event.target.result;
                                    document.body.appendChild(a);
                                    a.click();
                                    document.body.removeChild(a);
                                };
                                this.ExportPageVisible = false;
                            },
                            (response) => {
                            }
                        )
                    }
                })
            }
            ,
            getData() {
                this.loading = true
                this.axios.post('/api-s/10009/100070/' + this.pageNum + "/" + this.pageSize, this.query, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then((res) => {
                    console.log(res)
                    if (res.data.code === 10000) {

                        if (res.data.data !== null) {
                            let data = res.data.data;
                            this.tableData = data.records;
                            if (data.current !== undefined) {
                                this.pageNum = data.current;
                            } else {
                                this.pageNum = 1;
                            }
                            this.total = data.total;

                        } else {
                            this.$message.info('暂无订单')
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(() => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 分页导航
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            // 日期
            dateChange(val) {
                this.query.payStartTime = val[0]
                this.query.payEndTime = val[1]
            },
            // 打开处方明细
            openDetail(data) {
                this.detailVisible = true
                this.orderMessage = data
            },
            // 审核
            openAudit(data) {
                this.auditVisible = true
                this.orderMessage = data
            },
            // 售后
            openAfter(data) {
                this.afterVisible = true
                this.orderMessage = data
                this.afterEdit.afterType = 'REFUND_ALL'
            },
            // 获取省列表
            getProvince() {
                this.axios.get('/api-b/10028/100071', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.province = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取市列表
            getCity(val) {
                return new Promise(resolve => {
                    this.axios.get('/api-b/10028/100072?father=' + val, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        this.city = res.data.data
                        resolve(res)
                    })
                })
            },
            // 选择省
            chooseProvince(val) {
                this.getCity(val).then(res => {
                    if (res.data.code === 10000) {
                        this.area = []
                        this.chargeMessage.city = ''
                        this.chargeMessage.district = ''
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取区列表
            getArea(val) {
                return new Promise(resolve => {
                    this.axios.get('/api-b/10028/100073?father=' + val, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        resolve(res)
                        this.area = res.data.data
                    })
                })
            },
            // 选择市
            chooseCity(val) {
                this.getArea(val).then(res => {
                    if (res.data.code === 10000) {
                        this.chargeMessage.district = ''
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 确认收款
            confirmCharge(data) {
                let params = {
                    status: 1,
                    id: data.id
                }
                this.editOrder(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success('收款成功')
                        this.orderMessage = ''
                        this.chargeVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(() => {
                })

            },
            // 下拉列表选择
            handleCommand(command) {
                let item = command.button
                let data = command.data
                if (item === 'receivingEdit') {
                    this.openReceivingEdit(data)
                } else if (item === 'abandonedOrder') {
                    this.abandonedOrder(data)
                } else if (item === 'receivedOrder') {
                    this.receivedOrder(data)
                } else if (item === 'updateTrackingNumber') {
                    this.openUpdateTrackingNumber(data)
                }
            },
            composeValue(item, data) {
                return {
                    'button': item,
                    'data': data
                }
            },
            // 打开收货信息修改
            openReceivingEdit(data) {
                this.receivingEditVisible = true
                this.receivingEdit = JSON.parse(JSON.stringify(data))
                this.getProvince()
                this.getCity()
                this.getArea()
            },
            // 售后
            confirmAfterEdit() {
                this.$refs.afterEdit.validate(valid => {
                    if (valid) {
                        let params = {
                            type: this.afterEdit.afterType,
                            money: this.afterEdit.money,
                            remarks: this.afterEdit.remarks,
                            slaveId: this.orderMessage.id
                        }
                        this.axios.put('/api-s/10009/100181/', params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success('售后成功')
                                this.orderMessage = ''
                                this.afterVisible = false
                                this.getData()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        }).catch(() => {
                            this.$message.error(res.data.message)
                        })
                    } else {
                        this.$message.error('请按要求填写相关信息')
                    }
                })
            },
            // 确认修改收货地址
            confirmReceivingEdit() {
                this.$refs.receivingEdit.validate(valid => {
                    if (valid) {
                        let params = new FormData()
                        params.append("masterId", this.receivingEdit.masterId)
                        params.append("consigneeName", this.receivingEdit.consigneeName)
                        params.append("consigneePhone", this.receivingEdit.consigneePhone)
                        params.append("consigneeProvince", this.receivingEdit.consigneeProvince)
                        params.append("consigneeCity", this.receivingEdit.consigneeCity)
                        params.append("consigneeDistrict", this.receivingEdit.consigneeDistrict)
                        params.append("consigneeDetailAddress", this.receivingEdit.consigneeDetailAddress)
                        this.axios.post('/api-s/10009/100179/', params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success('修改收货信息成功')
                                this.orderMessage = ''
                                this.receivingEditVisible = false
                                this.receivingEdit = {}
                                this.getData()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        }).catch(() => {
                        })
                    } else {
                        this.$message.error('请按要求填写相关信息')
                    }
                })
            },
            // 打开发货
            openShipments(data) {
                this.orderMessage = data
                this.shipmentsVisible = true
            },
            // 快递确认发货
            confirmShipments() {
                this.$refs.courier.validate(valid => {
                    if (valid) {
                        let params = {
                            logisticsNumber: this.courier.trackingNumber,
                            logisticsCompany: this.courier.logisticsCompany,
                            status: 2,
                            id: this.orderMessage.id
                        }
                        this.editOrder(params).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success('发货成功')
                                this.orderMessage = ''
                                this.shipmentsVisible = false
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.courier.resetFields();
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        }).catch(() => {
                        })
                    } else {
                        this.$message.error('请按要求填写相关信息')
                    }
                })

            },
            //审核
            audit(data) {
                this.auditVisible = false
                let state = null;
                if (data) {
                    state = 1;
                } else {
                    state = 2;
                }
                let params = new FormData()
                params.append("orderDetailId", this.orderMessage.id)
                params.append("state", state)
                params.append("pharmacyId", this.orderMessage.pharmacyId)

                this.axios.post('/api-s/10009/100182/', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success('审批完成')
                        this.orderMessage = ''
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 订单改为已收货
            receivedOrder(data) {
                let params = {
                    status: 3,
                    id: data.id
                }
                this.editOrder(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success('订单已收货')
                        this.orderMessage = ''
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 废除订单
            abandonedOrder(data) {
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div', {class: 'message-box'}, [
                        h('div', {class: 'message-title-box'}, [
                            h('i', {class: 'el-icon-warning message-box-icon'}, ''),
                            h('span', {class: 'message-box-title'}, '确定将该订单作废？'),
                        ]),
                        h('div', null, [
                            h('span', {class: 'message-box-main'}, '作废后订单将移至“已作废”列表。'),
                        ]),
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {

                    this.axios.delete('/api-s/10009/100183/?id=' + data.id, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success('订单已作废')
                            this.orderMessage = ''
                            this.pharmacyVisible = false
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                })
            },
            exchangePharmacy() {
                var formData = new FormData();
                formData.append('OrderID', this.orderMessage.id);
                formData.append('pharmacyId', this.pharmacyId);

                this.axios.post('/api-s/10009/100184/', formData, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success('更换成功')
                        this.orderMessage = ''
                        this.pharmacyVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }
            ,

            // 修改订单
            editOrder(data) {
                return new Promise((resolve, reject) => {
                    this.axios.post('/api-s/10009/100094/', data, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        resolve(res)
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            towNumber(val) {
                return val.toFixed(2)
            },
            sumCount(data) {
                console.log(data)
                if (data != null) {
                    let totalSumAll = 0;

                    data.map((item) => {
                        if (item.convertQuantity != null) {
                            totalSumAll += (item.convertQuantity * this.printData.count);
                        } else {
                            totalSumAll += (item.count * this.printData.count);
                        }
                    })
                    if (isNaN(totalSumAll)) {
                        return 0
                    }
                    return totalSumAll.toFixed(2)
                }

            },
            sumOneCount(data) {
                console.log(data)
                if (data != null) {
                    let totalSumAll = 0;

                    data.map((item) => {
                        if (item.convertQuantity != null) {
                            totalSumAll += item.convertQuantity;
                        } else {
                            totalSumAll += item.count;
                        }
                    })
                    if (isNaN(totalSumAll)) {
                        return 0
                    }
                    return totalSumAll.toFixed(2)
                }

            },
            formatterX(row, column, cellValue, index) {
                return row.count + row.specification
            },
            getPharmacys() {
                let params = {
                    pageNum: 1,
                    pageSize: 999
                }
                this.axios.post('/api-b/10008/100088', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.pharmacies = res.data.data.list
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

        },
        watch: {
            // 监听搜索框值变化,请求列表数据
            query: {
                handler() {
                    setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep: true
            },
        },
        filters: { //局部过滤器
            toChies: function (amount) { //形参
                // 汉字的数字
                const cnNums = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
                // 基本单位
                const cnIntRadice = ["", "拾", "佰", "仟"];
                // 对应整数部分扩展单位
                const cnIntUnits = ["", "万", "亿", "兆"];
                // 对应小数部分单位
                const cnDecUnits = ["角", "分"];
                // 整数金额时后面跟的字符
                const cnInteger = "整";
                // 整型完以后的单位
                const cnIntLast = "元";
                // 最大处理的数字
                const maxNum = 9999999999999999.99;
                // 金额整数部分
                let integerNum;
                // 金额小数部分
                let decimalNum;
                // 输出的中文金额字符串
                let chineseStr = "";
                // 分离金额后用的数组，预定义
                let parts;
                if (amount === "") {
                    return "";
                }
                amount = parseFloat(amount);
                if (amount >= maxNum) {
                    // 超出最大处理数字
                    return "";
                }
                if (amount === 0) {
                    chineseStr = cnNums[0] + cnIntLast + cnInteger;
                    return chineseStr;
                }
                // 转换为字符串
                amount = amount.toString();
                if (amount.indexOf(".") === -1) {
                    integerNum = amount;

                    decimalNum = "";
                } else {
                    parts = amount.split(".");
                    integerNum = parts[0];
                    decimalNum = parts[1].substr(0, 4);
                }
                // 获取整型部分转换
                if (parseInt(integerNum, 10) > 0) {
                    let zeroCount = 0;
                    const IntLen = integerNum.length;
                    for (let i = 0; i < IntLen; i++) {
                        const n = integerNum.substr(i, 1);
                        const p = IntLen - i - 1;
                        const q = p / 4;
                        const m = p % 4;
                        if (n === "0") {
                            zeroCount++;
                        } else {
                            if (zeroCount > 0) {
                                chineseStr += cnNums[0];
                            }
                            // 归零
                            zeroCount = 0;
                            //alert(cnNums[parseInt(n)])
                            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                        }
                        if (m === 0 && zeroCount < 4) {
                            chineseStr += cnIntUnits[q];
                        }
                    }
                    chineseStr += cnIntLast;
                }
                // 小数部分
                if (decimalNum !== "") {
                    const decLen = decimalNum.length;
                    for (let i = 0; i < decLen; i++) {
                        const n = decimalNum.substr(i, 1);
                        if (n !== "0") {
                            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                        }
                    }
                }
                if (chineseStr === "") {
                    chineseStr += cnNums[0] + cnIntLast + cnInteger;
                } else if (decimalNum === "") {
                    chineseStr += cnInteger;
                }
                return chineseStr;
            }
        },
        computed: {
            addtotal() {
                let total = 0;
                let totalSmall = this.infoData.detail
                totalSmall.map((item) => {
                    if (item.amount == '') {
                        item.amount = 0;
                    }
                    total += Number(item.amount)
                })
                return total.toFixed(2)//四舍五入保留两位
            }
        }

    };
</script>

<style>
    /*.customer-table th {*/
    /*    border: none;*/
    /*}*/


    /*table th,*/
    .customer-table td {
        border: none;
        border-bottom: none !important;
    }

    .customer-table-tr tbody tr {
        pointer-events: none;
    }

    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }

    .el-button--primary:hover {
        background: rgba(120, 180, 255, 1) !important;
        color: #FFFFFF !important;
        border: none !important;
    }

    .el-button--primary:focus {
        background: rgba(57, 129, 221, 1) !important;
        color: #FFFFFF !important;
        border: none !important;
    }

    .el-dropdown-link {
        margin-left: 10px;
        cursor: pointer;
        color: rgba(97, 167, 255, 0.8);
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 12px;
        height: 58px;
    }

    .input-width {
        width: 160px;
    }

    .dialog-set {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }

    .mr20 {
        margin-right: 20px;
    }

    .date-bg {
        background: #FFFFFF !important;
    }

    .line {
        height: 1px;
        width: 100%;
        background: #EEEEEE;
    }
</style>
